module.exports = __webpack_public_path__ + "static/img/5.767c613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/5.jpg
// module id = vTU/
// module chunks = 12